<template>
  <!-- eslint-disable -->
  <div class="container-root festive-lights">
    <div class="container-header">
      <svg
        class="header-lights"
        version="1.1"
        id="Layer_1-header-lights"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 190 18"
        style="enable-background: new 0 0 190 18"
        xml:space="preserve">
        <g class="cst0">
          <path
            class="cst1"
            d="M-0.3,24.9c0,0,36-46.7,87.3-44.7c51.3,2,90.7,52.9,146.7,52.3c78-0.8,131.2-53.8,184-54.8
		c52.8-1,110.3,52.5,189,55s129.6-47.9,152-52.5c22.3-4.6,28.4,23.9,20.3,29.4c-8.1,5.6-16.8-5.6-10.7-13.2
		c6.1-7.6,25.4-18.3,46.2-15.7" />
          <g class="cst2">
            <radialGradient
              id="CSVGID_1_"
              cx="11.162"
              cy="-5.2264"
              r="8.7832"
              gradientTransform="matrix(0.7698 -0.6383 0.6383 0.7698 5.6472 8.6734)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst3" cx="10.9" cy="-2.5" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M15.3-2.4c1.3,1.6,1,4.3,0,5.1c-1,0.8-3.8,0.7-5.1-0.9C8.8,0.2,6.8-4.5,8.2-5.7C9.6-6.9,14-4,15.3-2.4z" />
              <path
                class="cst5"
                d="M15.5,0.8l-2.2,1.8c-0.2,0.2,0,0.8,0.2,1l0.7,0.8c0.2,0.2,0.3,0.4,0.3,0.4l1.6,2c0.2,0.2,1.1,0.4,1.3,0.2
				L19,5.7c0.2-0.2,0.3-1.2,0.2-1.4l-1.6-2c0-0.1-0.2-0.2-0.3-0.4l-0.7-0.8C16.3,0.9,15.7,0.6,15.5,0.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_2_"
              cx="62.0493"
              cy="4.6493"
              r="8.7829"
              gradientTransform="matrix(0.9613 -0.2757 0.2757 0.9613 -3.5394 -15.094)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst6" cx="57.4" cy="-27.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M61.4-25.9c0.6,2-0.8,4.3-2,4.7c-1.3,0.4-3.8-0.9-4.3-2.9c-0.6-2-0.5-7.2,1.2-7.7
				C58-32.3,60.8-27.9,61.4-25.9z" />
              <path
                class="cst5"
                d="M60.3-22.9l-2.8,0.8c-0.3,0.1-0.3,0.7-0.2,1l0.3,1c0.1,0.2,0.1,0.4,0.1,0.5l0.7,2.5c0.1,0.3,0.8,0.8,1.1,0.7
				l2-0.6c0.3-0.1,0.8-0.9,0.7-1.2l-0.7-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.3-1C61-22.5,60.5-23,60.3-22.9z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_3_"
              cx="129.5939"
              cy="30.4383"
              r="8.7832"
              gradientTransform="matrix(0.9076 0.4199 -0.4199 0.9076 26.4847 -101.7022)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst7" cx="131.3" cy="-19.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M133.1-15.7c-0.9,1.9-3.5,2.7-4.6,2.2c-1.2-0.6-2.3-3.1-1.4-5c0.9-1.9,4.3-5.8,6-5
				C134.7-22.7,134-17.6,133.1-15.7z" />
              <path
                class="cst5"
                d="M130.3-14.1l-2.6-1.2c-0.3-0.1-0.7,0.3-0.8,0.6l-0.4,1c-0.1,0.2-0.2,0.4-0.2,0.5l-1.1,2.3
				c-0.1,0.3,0.1,1.1,0.4,1.3l1.9,0.9c0.3,0.1,1.2-0.2,1.3-0.5l1.1-2.3c0-0.1,0.1-0.3,0.2-0.5l0.4-1C130.6-13.3,130.6-14,130.3-14.1
				z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_4_"
              cx="195.7356"
              cy="32.8923"
              r="8.7832"
              gradientTransform="matrix(0.9076 0.4199 -0.4199 0.9076 26.4847 -101.7022)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst8" cx="190.3" cy="10.3" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M192.1,14.3c-0.9,1.9-3.5,2.8-4.6,2.2c-1.2-0.6-2.3-3.1-1.4-5c0.9-1.9,4.3-5.8,6-5
				C193.7,7.3,193,12.4,192.1,14.3z" />
              <path
                class="cst5"
                d="M189.3,15.9l-2.6-1.2c-0.3-0.1-0.7,0.3-0.8,0.6l-0.4,1c-0.1,0.2-0.2,0.4-0.2,0.5l-1.1,2.3
				c-0.1,0.3,0.1,1.1,0.4,1.3l1.9,0.9c0.3,0.1,1.2-0.2,1.3-0.5l1.1-2.3c0-0.1,0.1-0.3,0.2-0.5l0.4-1C189.6,16.7,189.6,16,189.3,15.9
				z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_5_"
              cx="258.0028"
              cy="5.8534"
              r="8.7833"
              gradientTransform="matrix(0.978 -0.2087 0.2087 0.978 2.9314 67.3661)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst9" cx="256.5" cy="19.2" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M260.3,21.3c0.4,2-1.1,4.3-2.4,4.5c-1.3,0.3-3.7-1.1-4.1-3.2c-0.4-2,0-7.2,1.8-7.6
				C257.4,14.8,259.9,19.3,260.3,21.3z" />
              <path
                class="cst5"
                d="M259,24.3l-2.8,0.6c-0.3,0.1-0.4,0.7-0.3,1l0.2,1c0.1,0.2,0.1,0.4,0.1,0.5l0.5,2.5c0.1,0.3,0.8,0.8,1.1,0.8
				l2.1-0.4c0.3-0.1,0.8-0.9,0.8-1.2l-0.5-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.2-1C259.7,24.7,259.3,24.2,259,24.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_6_"
              cx="327.9486"
              cy="-1.1043"
              r="8.7832"
              gradientTransform="matrix(0.9435 -0.3315 0.3315 0.9435 14.2618 108.0487)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst10" cx="323.3" cy="-1.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M327.4-0.1c0.7,1.9-0.6,4.4-1.8,4.8c-1.3,0.4-3.8-0.7-4.5-2.6c-0.7-1.9-0.9-7.1,0.8-7.7
				C323.6-6.3,326.7-2.1,327.4-0.1z" />
              <path
                class="cst5"
                d="M326.5,3l-2.7,1c-0.3,0.1-0.3,0.7-0.2,1l0.3,1c0.1,0.2,0.2,0.4,0.2,0.5l0.9,2.4c0.1,0.3,0.9,0.7,1.2,0.6
				l2-0.7c0.3-0.1,0.7-1,0.6-1.3l-0.9-2.4c0-0.1-0.1-0.3-0.2-0.5l-0.3-1C327.2,3.3,326.7,2.9,326.5,3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_7_"
              cx="395.9532"
              cy="-5.5637"
              r="8.7832"
              gradientTransform="matrix(0.9534 -0.3019 0.3019 0.9534 10.5328 96.1213)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst11" cx="386.4" cy="-28.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M390.4-27c0.6,2-0.7,4.4-1.9,4.8c-1.3,0.4-3.8-0.8-4.4-2.7c-0.6-2-0.7-7.2,1-7.7
				C386.8-33.3,389.8-29,390.4-27z" />
              <path
                class="cst5"
                d="M389.4-23.9l-2.7,0.9c-0.3,0.1-0.3,0.7-0.2,1l0.3,1c0.1,0.2,0.1,0.4,0.2,0.5l0.8,2.4
				c0.1,0.3,0.9,0.8,1.1,0.7l2-0.6c0.3-0.1,0.8-0.9,0.7-1.2l-0.8-2.4c0-0.1-0.1-0.3-0.2-0.5l-0.3-1C390.1-23.6,389.6-24,389.4-23.9z
				" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_8_"
              cx="485.9456"
              cy="27.0971"
              r="8.7834"
              gradientTransform="matrix(0.9067 0.4218 -0.4218 0.9067 54.1484 -246.1999)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst12" cx="483.3" cy="-16.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M485.1-12.7c-0.9,1.9-3.5,2.7-4.6,2.2c-1.2-0.6-2.3-3.1-1.4-5c0.9-1.9,4.3-5.8,6-5
				C486.8-19.7,486-14.6,485.1-12.7z" />
              <path
                class="cst5"
                d="M482.3-11.1l-2.6-1.2c-0.3-0.1-0.7,0.3-0.8,0.6l-0.4,1c-0.1,0.2-0.2,0.4-0.2,0.5L477.1-8
				c-0.1,0.3,0.1,1.1,0.4,1.3l1.9,0.9c0.3,0.1,1.2-0.2,1.3-0.5l1.1-2.3c0-0.1,0.1-0.3,0.2-0.5l0.4-1C482.6-10.3,482.6-11,482.3-11.1
				z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_9_"
              cx="571.7973"
              cy="21.5746"
              r="8.7835"
              gradientTransform="matrix(0.9621 0.2727 -0.2727 0.9621 18.8833 -162.4197)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst13" cx="563.1" cy="14.3" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M565.5,17.9c-0.6,2-3,3.3-4.2,2.9c-1.3-0.4-2.7-2.7-2.2-4.7c0.6-2,3.3-6.4,5.1-5.9
				C566,10.7,566.1,15.9,565.5,17.9z" />
              <path
                class="cst5"
                d="M563,19.9l-2.8-0.8c-0.3-0.1-0.6,0.4-0.7,0.7l-0.3,1c-0.1,0.2-0.1,0.4-0.1,0.5l-0.7,2.5
				c-0.1,0.3,0.3,1.1,0.6,1.2l2,0.6c0.3,0.1,1.2-0.4,1.2-0.7l0.7-2.5c0-0.1,0.1-0.3,0.1-0.5l0.3-1C563.4,20.6,563.3,20,563,19.9z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_10_"
              cx="646.582"
              cy="-2.3606"
              r="8.7838"
              gradientTransform="matrix(0.9834 -0.1812 0.1812 0.9834 4.096 138.7198)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst14" cx="639.5" cy="19.2" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M643.3,21.4c0.4,2-1.2,4.2-2.5,4.5c-1.3,0.2-3.7-1.2-4-3.3c-0.4-2,0.2-7.2,2-7.5
				C640.6,14.8,642.9,19.4,643.3,21.4z" />
              <path
                class="cst5"
                d="M641.9,24.4l-2.8,0.5c-0.3,0.1-0.4,0.7-0.3,1l0.2,1c0,0.2,0.1,0.5,0.1,0.5l0.5,2.5c0.1,0.3,0.8,0.9,1.1,0.8
				l2.1-0.4c0.3-0.1,0.9-0.8,0.8-1.1l-0.5-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.2-1C642.6,24.8,642.2,24.3,641.9,24.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_11_"
              cx="715.0056"
              cy="-14.0322"
              r="8.7835"
              gradientTransform="matrix(0.8869 -0.462 0.462 0.8869 77.4847 338.1451)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst15" cx="705.1" cy="-4.6" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M709.4-3.6c1,1.8,0.1,4.4-1.1,5c-1.2,0.6-3.9-0.1-4.8-1.9c-1-1.8-1.9-6.9-0.3-7.8
				C704.8-9.2,708.4-5.5,709.4-3.6z" />
              <path
                class="cst5"
                d="M708.9-0.4l-2.5,1.3c-0.3,0.1-0.2,0.7,0,1l0.5,0.9c0.1,0.2,0.2,0.4,0.2,0.5l1.2,2.3c0.1,0.3,1,0.6,1.2,0.5
				l1.9-1c0.3-0.1,0.6-1.1,0.4-1.3l-1.2-2.3c0-0.1-0.1-0.2-0.2-0.5l-0.5-0.9C709.7-0.2,709.2-0.6,708.9-0.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_12_"
              cx="780.7552"
              cy="-13.4833"
              r="8.7833"
              gradientTransform="matrix(0.9998 2.170000e-02 -2.170000e-02 0.9998 -16.1035 -35.2458)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst16" cx="764.8" cy="-31.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M768-28.9c0,2.1-2.1,3.9-3.3,3.9c-1.3,0-3.3-2-3.3-4c0-2.1,1.6-7,3.5-7C766.7-35.9,768.1-30.9,768-28.9z" />
              <path
                class="cst5"
                d="M766.1-26.3l-2.9-0.1c-0.3,0-0.5,0.6-0.5,0.9l0,1.1c0,0.2,0,0.5,0,0.5l-0.1,2.6c0,0.3,0.6,1,0.9,1l2.1,0
				c0.3,0,1-0.6,1-1l0.1-2.6c0-0.1,0-0.3,0-0.5l0-1.1C766.7-25.7,766.4-26.3,766.1-26.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_13_"
              cx="806.1928"
              cy="2.5494"
              r="8.7839"
              gradientTransform="matrix(-5.230000e-02 0.9986 -0.9986 -5.230000e-02 838.808 -804.3041)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst17" cx="794.1" cy="0.6" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M791.1,3.8c-2.1-0.1-3.8-2.2-3.8-3.5c0.1-1.3,2.1-3.3,4.1-3.2c2.1,0.1,7,1.8,6.9,3.7
				C798.2,2.7,793.1,3.9,791.1,3.8z" />
              <path
                class="cst5"
                d="M788.6,1.8l0.1-2.9c0-0.3-0.5-0.5-0.9-0.5l-1-0.1c-0.2,0-0.5,0-0.5,0l-2.6-0.1c-0.3,0-1,0.5-1,0.8l-0.1,2.1
				c0,0.3,0.6,1,0.9,1.1l2.6,0.1c0.1,0,0.3,0,0.5,0l1.1,0.1C788,2.3,788.5,2.1,788.6,1.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_14_"
              cx="845.484"
              cy="17.5076"
              r="8.7831"
              gradientTransform="matrix(-0.6718 -0.7408 0.7408 -0.6718 1314.7922 653.5539)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst18" cx="759.8" cy="15.5" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M759.6,11.1c1.5-1.4,4.3-1.2,5.1-0.2c0.9,1,0.9,3.8-0.7,5.1c-1.5,1.4-6.2,3.6-7.4,2.3
				C755.4,16.9,758.1,12.5,759.6,11.1z" />
              <path
                class="cst5"
                d="M762.9,10.7l1.9,2.1c0.2,0.2,0.8,0,1-0.2l0.8-0.7c0.2-0.2,0.3-0.3,0.4-0.4l1.9-1.7c0.2-0.2,0.3-1.1,0.1-1.3
				L767.6,7c-0.2-0.2-1.2-0.3-1.4-0.1l-1.9,1.7c-0.1,0-0.2,0.2-0.4,0.4l-0.8,0.7C762.9,9.9,762.7,10.5,762.9,10.7z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_15_"
              cx="864.4544"
              cy="69.8088"
              r="8.7836"
              gradientTransform="matrix(0.9706 -0.2406 0.2406 0.9706 -61.3987 110.4873)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst19" cx="794.4" cy="-29.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M798.3-27.8c0.5,2-1,4.3-2.2,4.6c-1.3,0.3-3.7-1-4.2-3c-0.5-2-0.3-7.2,1.5-7.6
				C795.2-34.3,797.8-29.8,798.3-27.8z" />
              <path
                class="cst5"
                d="M797.1-24.8l-2.8,0.7c-0.3,0.1-0.3,0.7-0.3,1l0.3,1c0.1,0.2,0.1,0.4,0.1,0.5l0.6,2.5
				c0.1,0.3,0.8,0.8,1.1,0.7l2-0.5c0.3-0.1,0.8-0.9,0.7-1.2l-0.6-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.3-1
				C797.9-24.4,797.4-24.9,797.1-24.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_16_"
              cx="57.4555"
              cy="61.0163"
              r="8.7832"
              gradientTransform="matrix(-0.8752 0.4838 -0.4838 -0.8752 123.2143 28.3373)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst20" cx="43.4" cy="2.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M39.1,1.9c-1-1.8-0.2-4.4,0.9-5c1.2-0.6,3.9,0,4.9,1.8c1,1.8,2.1,6.9,0.5,7.8C43.8,7.3,40.1,3.7,39.1,1.9z" />
              <path
                class="cst5"
                d="M39.5-1.4L42-2.8c0.3-0.1,0.2-0.7,0-1l-0.5-0.9c-0.1-0.2-0.2-0.4-0.3-0.5l-1.2-2.2c-0.1-0.3-1-0.6-1.3-0.4
				l-1.8,1c-0.3,0.1-0.6,1.1-0.4,1.3l1.2,2.2c0,0.1,0.1,0.2,0.3,0.5l0.5,0.9C38.7-1.6,39.3-1.2,39.5-1.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_17_"
              cx="9.065"
              cy="46.1228"
              r="8.7831"
              gradientTransform="matrix(-0.9923 -0.1242 0.1242 -0.9923 95.8603 38.7832)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst21" cx="92.6" cy="-8.1" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M89.7-11.3c0.3-2,2.5-3.7,3.7-3.5c1.3,0.2,3.1,2.3,2.9,4.3c-0.3,2-2.3,6.8-4.2,6.6
				C90.3-4.2,89.4-9.3,89.7-11.3z" />
              <path
                class="cst5"
                d="M91.9-13.7l2.8,0.4c0.3,0,0.6-0.5,0.6-0.8l0.1-1c0-0.2,0.1-0.5,0.1-0.5l0.3-2.5c0-0.3-0.5-1-0.8-1.1L93-19.6
				c-0.3,0-1.1,0.5-1.1,0.8l-0.3,2.5c0,0.1,0,0.3-0.1,0.5l-0.1,1C91.3-14.4,91.6-13.7,91.9-13.7z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_18_"
              cx="-50.4849"
              cy="30.0675"
              r="8.7834"
              gradientTransform="matrix(-0.8707 -0.4918 0.4918 -0.8707 91.3561 17.078)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst22" cx="150.1" cy="15.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M148.6,11.6c1-1.8,3.7-2.5,4.8-1.8c1.2,0.7,2,3.3,1,5.1c-1,1.8-4.8,5.4-6.3,4.5
				C146.4,18.5,147.6,13.4,148.6,11.6z" />
              <path
                class="cst5"
                d="M151.6,10.3l2.5,1.4c0.3,0.2,0.7-0.3,0.9-0.5l0.5-0.9c0.1-0.2,0.2-0.4,0.3-0.5l1.3-2.2
				c0.2-0.3,0-1.1-0.3-1.3l-1.8-1c-0.3-0.1-1.2,0.1-1.4,0.4l-1.3,2.2c0,0.1-0.1,0.2-0.3,0.5l-0.5,0.9
				C151.3,9.5,151.3,10.1,151.6,10.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_19_"
              cx="-126.2008"
              cy="40.9624"
              r="8.7837"
              gradientTransform="matrix(-0.9931 -0.117 0.117 -0.9931 91.4809 68.8053)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst23" cx="221.6" cy="42.9" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M218.6,39.7c0.2-2,2.4-3.7,3.7-3.5c1.3,0.2,3.1,2.3,2.9,4.3c-0.2,2-2.3,6.8-4.1,6.6
				C219.3,46.9,218.4,41.7,218.6,39.7z" />
              <path
                class="cst5"
                d="M220.8,37.3l2.9,0.3c0.3,0,0.6-0.5,0.6-0.8l0.1-1c0-0.2,0.1-0.5,0.1-0.5l0.3-2.5c0-0.3-0.5-1-0.8-1.1
				l-2.1-0.2c-0.3,0-1.1,0.5-1.1,0.9l-0.3,2.5c0,0.1,0,0.3-0.1,0.5l-0.1,1C220.3,36.7,220.5,37.3,220.8,37.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_20_"
              cx="-199.4359"
              cy="69.4943"
              r="8.7831"
              gradientTransform="matrix(-0.9269 0.3754 -0.3754 -0.9269 140.4957 171.0848)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst24" cx="299.3" cy="31.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M295.1,30.4c-0.8-1.9,0.4-4.4,1.5-4.9c1.2-0.5,3.8,0.5,4.6,2.4c0.8,1.9,1.3,7.1-0.4,7.8
				C299.1,36.4,295.9,32.3,295.1,30.4z" />
              <path
                class="cst5"
                d="M295.9,27.3l2.7-1.1c0.3-0.1,0.3-0.7,0.1-1l-0.4-1c-0.1-0.2-0.2-0.4-0.2-0.5l-1-2.4
				c-0.1-0.3-0.9-0.7-1.2-0.6l-1.9,0.8c-0.3,0.1-0.7,1-0.6,1.3l1,2.4c0,0.1,0.1,0.3,0.2,0.5l0.4,1C295.1,27,295.6,27.4,295.9,27.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_21_"
              cx="-268.8126"
              cy="71.0208"
              r="8.7834"
              gradientTransform="matrix(-0.9099 0.4148 -0.4148 -0.9099 148.1842 180.9048)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst25" cx="363.3" cy="4.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M359.1,3.6c-0.9-1.9,0.2-4.4,1.3-4.9c1.2-0.5,3.9,0.3,4.7,2.2c0.9,1.9,1.6,7-0.1,7.8
				C363.4,9.4,360,5.4,359.1,3.6z" />
              <path
                class="cst5"
                d="M359.8,0.4l2.6-1.2c0.3-0.1,0.2-0.7,0.1-1l-0.4-1c-0.1-0.2-0.2-0.4-0.2-0.5l-1.1-2.3
				c-0.1-0.3-0.9-0.6-1.2-0.5l-1.9,0.9c-0.3,0.1-0.6,1-0.5,1.3l1.1,2.3c0,0.1,0.1,0.3,0.2,0.5l0.4,1C359,0.1,359.5,0.5,359.8,0.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_22_"
              cx="-341.5268"
              cy="53.7822"
              r="8.7838"
              gradientTransform="matrix(-0.9826 -0.1855 0.1855 -0.9826 89.9502 -19.6301)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst26" cx="435.5" cy="-9.1" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M432.8-12.5c0.4-2,2.7-3.5,3.9-3.3c1.3,0.2,3,2.5,2.6,4.5c-0.4,2-2.8,6.6-4.6,6.3
				C432.9-5.3,432.4-10.5,432.8-12.5z" />
              <path
                class="cst5"
                d="M435.1-14.8l2.8,0.5c0.3,0.1,0.6-0.5,0.7-0.8l0.2-1c0-0.2,0.1-0.4,0.1-0.5l0.5-2.5c0.1-0.3-0.4-1.1-0.7-1.1
				l-2.1-0.4c-0.3-0.1-1.1,0.5-1.2,0.8l-0.5,2.5c0,0.1-0.1,0.3-0.1,0.5l-0.2,1C434.6-15.4,434.8-14.8,435.1-14.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_23_"
              cx="-423.2584"
              cy="36.5655"
              r="8.7834"
              gradientTransform="matrix(-0.9265 -0.3763 0.3763 -0.9265 107.3465 -104.5927)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst27" cx="513.3" cy="20.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M511.3,16.9c0.8-1.9,3.3-2.9,4.5-2.4c1.2,0.5,2.4,3,1.6,4.9c-0.8,1.9-4,6-5.7,5.3
				C510,24,510.5,18.8,511.3,16.9z" />
              <path
                class="cst5"
                d="M514,15.2l2.7,1.1c0.3,0.1,0.7-0.3,0.8-0.6l0.4-1c0.1-0.2,0.2-0.4,0.2-0.5l1-2.4c0.1-0.3-0.2-1.1-0.5-1.2
				l-1.9-0.8c-0.3-0.1-1.2,0.2-1.3,0.5l-1,2.4c0,0.1-0.1,0.3-0.2,0.5l-0.4,1C513.6,14.4,513.7,15.1,514,15.2z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_24_"
              cx="-514.5245"
              cy="49.5535"
              r="8.7839"
              gradientTransform="matrix(-0.9995 -3.020000e-02 3.020000e-02 -0.9995 86.9557 77.8894)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst28" cx="602.7" cy="43.9" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M599.5,41c0.1-2.1,2.1-3.9,3.4-3.8c1.3,0,3.3,2,3.2,4c-0.1,2.1-1.7,7-3.5,6.9C600.8,48,599.4,43,599.5,41z" />
              <path
                class="cst5"
                d="M601.5,38.4l2.9,0.1c0.3,0,0.5-0.6,0.5-0.9l0-1c0-0.2,0-0.5,0-0.5l0.1-2.6c0-0.3-0.6-1-0.9-1l-2.1-0.1
				c-0.3,0-1,0.6-1,0.9l-0.1,2.6c0,0.1,0,0.3,0,0.5l0,1C600.9,37.8,601.2,38.4,601.5,38.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_25_"
              cx="-593.5144"
              cy="64.133"
              r="8.7833"
              gradientTransform="matrix(-0.9414 0.3374 -0.3374 -0.9414 145.1165 291.4482)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst29" cx="682.2" cy="30.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M678.1,29.3c-0.7-1.9,0.5-4.4,1.7-4.8c1.2-0.4,3.8,0.6,4.5,2.6c0.7,1.9,1,7.1-0.7,7.7
				C681.9,35.4,678.8,31.2,678.1,29.3z" />
              <path
                class="cst5"
                d="M679,26.2l2.7-1c0.3-0.1,0.3-0.7,0.2-1l-0.4-1c-0.1-0.2-0.2-0.4-0.2-0.5l-0.9-2.4c-0.1-0.3-0.9-0.7-1.2-0.6
				l-2,0.7c-0.3,0.1-0.7,1-0.6,1.3l0.9,2.4c0,0.1,0.1,0.3,0.2,0.5l0.4,1C678.3,25.8,678.8,26.3,679,26.2z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_26_"
              cx="-661.9906"
              cy="72.7947"
              r="8.7839"
              gradientTransform="matrix(-0.8713 0.4907 -0.4907 -0.8713 203.3462 387.9924)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst30" cx="744.4" cy="-0.3" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M740.1-1.1c-1-1.8-0.2-4.4,0.9-5c1.2-0.7,3.9,0,4.9,1.8c1,1.8,2.2,6.9,0.6,7.8
				C744.9,4.3,741.1,0.7,740.1-1.1z" />
              <path
                class="cst5"
                d="M740.5-4.3l2.5-1.4c0.3-0.1,0.2-0.7,0-1l-0.5-0.9c-0.1-0.2-0.2-0.4-0.3-0.5l-1.3-2.2c-0.2-0.3-1-0.6-1.3-0.4
				l-1.8,1c-0.3,0.2-0.5,1.1-0.4,1.3l1.3,2.2c0,0.1,0.1,0.2,0.3,0.5l0.5,0.9C739.7-4.5,740.2-4.2,740.5-4.3z" />
            </g>
          </g>
        </g>
        <g id="_x31_" class="cst0">
          <path
            class="cst1"
            d="M-0.3,24.9c0,0,36-46.7,87.3-44.7c51.3,2,90.7,52.9,146.7,52.3c78-0.8,131.2-53.8,184-54.8
		c52.8-1,110.3,52.5,189,55s129.6-47.9,152-52.5c22.3-4.6,28.4,23.9,20.3,29.4c-8.1,5.6-16.8-5.6-10.7-13.2
		c6.1-7.6,25.4-18.3,46.2-15.7" />
          <g class="cst2">
            <radialGradient
              id="CSVGID_27_"
              cx="11.162"
              cy="-5.2264"
              r="8.7832"
              gradientTransform="matrix(0.7698 -0.6383 0.6383 0.7698 5.6472 8.6734)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst31" cx="10.9" cy="-2.5" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M15.3-2.4c1.3,1.6,1,4.3,0,5.1c-1,0.8-3.8,0.7-5.1-0.9C8.8,0.2,6.8-4.5,8.2-5.7C9.6-6.9,14-4,15.3-2.4z" />
              <path
                class="cst5"
                d="M15.5,0.8l-2.2,1.8c-0.2,0.2,0,0.8,0.2,1l0.7,0.8c0.2,0.2,0.3,0.4,0.3,0.4l1.6,2c0.2,0.2,1.1,0.4,1.3,0.2
				L19,5.7c0.2-0.2,0.3-1.2,0.2-1.4l-1.6-2c0-0.1-0.2-0.2-0.3-0.4l-0.7-0.8C16.3,0.9,15.7,0.6,15.5,0.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_28_"
              cx="62.0493"
              cy="4.6493"
              r="8.7829"
              gradientTransform="matrix(0.9613 -0.2757 0.2757 0.9613 -3.5394 -15.094)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst32" cx="57.4" cy="-27.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M61.4-25.9c0.6,2-0.8,4.3-2,4.7c-1.3,0.4-3.8-0.9-4.3-2.9c-0.6-2-0.5-7.2,1.2-7.7
				C58-32.3,60.8-27.9,61.4-25.9z" />
              <path
                class="cst5"
                d="M60.3-22.9l-2.8,0.8c-0.3,0.1-0.3,0.7-0.2,1l0.3,1c0.1,0.2,0.1,0.4,0.1,0.5l0.7,2.5c0.1,0.3,0.8,0.8,1.1,0.7
				l2-0.6c0.3-0.1,0.8-0.9,0.7-1.2l-0.7-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.3-1C61-22.5,60.5-23,60.3-22.9z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_29_"
              cx="129.5939"
              cy="30.4383"
              r="8.7832"
              gradientTransform="matrix(0.9076 0.4199 -0.4199 0.9076 26.4847 -101.7022)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst33" cx="131.3" cy="-19.7" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M133.1-15.7c-0.9,1.9-3.5,2.7-4.6,2.2c-1.2-0.6-2.3-3.1-1.4-5c0.9-1.9,4.3-5.8,6-5
				C134.7-22.7,134-17.6,133.1-15.7z" />
              <path
                class="cst5"
                d="M130.3-14.1l-2.6-1.2c-0.3-0.1-0.7,0.3-0.8,0.6l-0.4,1c-0.1,0.2-0.2,0.4-0.2,0.5l-1.1,2.3
				c-0.1,0.3,0.1,1.1,0.4,1.3l1.9,0.9c0.3,0.1,1.2-0.2,1.3-0.5l1.1-2.3c0-0.1,0.1-0.3,0.2-0.5l0.4-1C130.6-13.3,130.6-14,130.3-14.1
				z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_30_"
              cx="195.7356"
              cy="32.8923"
              r="8.7832"
              gradientTransform="matrix(0.9076 0.4199 -0.4199 0.9076 26.4847 -101.7022)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst35" cx="190.3" cy="10.3" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M192.1,14.3c-0.9,1.9-3.5,2.8-4.6,2.2c-1.2-0.6-2.3-3.1-1.4-5c0.9-1.9,4.3-5.8,6-5
				C193.7,7.3,193,12.4,192.1,14.3z" />
              <path
                class="cst5"
                d="M189.3,15.9l-2.6-1.2c-0.3-0.1-0.7,0.3-0.8,0.6l-0.4,1c-0.1,0.2-0.2,0.4-0.2,0.5l-1.1,2.3
				c-0.1,0.3,0.1,1.1,0.4,1.3l1.9,0.9c0.3,0.1,1.2-0.2,1.3-0.5l1.1-2.3c0-0.1,0.1-0.3,0.2-0.5l0.4-1C189.6,16.7,189.6,16,189.3,15.9
				z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_31_"
              cx="258.0028"
              cy="5.8534"
              r="8.7833"
              gradientTransform="matrix(0.978 -0.2087 0.2087 0.978 2.9314 67.3661)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst36" cx="256.5" cy="19.2" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M260.3,21.3c0.4,2-1.1,4.3-2.4,4.5c-1.3,0.3-3.7-1.1-4.1-3.2c-0.4-2,0-7.2,1.8-7.6
				C257.4,14.8,259.9,19.3,260.3,21.3z" />
              <path
                class="cst5"
                d="M259,24.3l-2.8,0.6c-0.3,0.1-0.4,0.7-0.3,1l0.2,1c0.1,0.2,0.1,0.4,0.1,0.5l0.5,2.5c0.1,0.3,0.8,0.8,1.1,0.8
				l2.1-0.4c0.3-0.1,0.8-0.9,0.8-1.2l-0.5-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.2-1C259.7,24.7,259.3,24.2,259,24.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_32_"
              cx="327.9486"
              cy="-1.1043"
              r="8.7832"
              gradientTransform="matrix(0.9435 -0.3315 0.3315 0.9435 14.2618 108.0487)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst37" cx="323.3" cy="-1.7" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M327.4-0.1c0.7,1.9-0.6,4.4-1.8,4.8c-1.3,0.4-3.8-0.7-4.5-2.6c-0.7-1.9-0.9-7.1,0.8-7.7
				C323.6-6.3,326.7-2.1,327.4-0.1z" />
              <path
                class="cst5"
                d="M326.5,3l-2.7,1c-0.3,0.1-0.3,0.7-0.2,1l0.3,1c0.1,0.2,0.2,0.4,0.2,0.5l0.9,2.4c0.1,0.3,0.9,0.7,1.2,0.6
				l2-0.7c0.3-0.1,0.7-1,0.6-1.3l-0.9-2.4c0-0.1-0.1-0.3-0.2-0.5l-0.3-1C327.2,3.3,326.7,2.9,326.5,3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_33_"
              cx="395.9532"
              cy="-5.5637"
              r="8.7832"
              gradientTransform="matrix(0.9534 -0.3019 0.3019 0.9534 10.5328 96.1213)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst38" cx="386.4" cy="-28.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M390.4-27c0.6,2-0.7,4.4-1.9,4.8c-1.3,0.4-3.8-0.8-4.4-2.7c-0.6-2-0.7-7.2,1-7.7
				C386.8-33.3,389.8-29,390.4-27z" />
              <path
                class="cst5"
                d="M389.4-23.9l-2.7,0.9c-0.3,0.1-0.3,0.7-0.2,1l0.3,1c0.1,0.2,0.1,0.4,0.2,0.5l0.8,2.4
				c0.1,0.3,0.9,0.8,1.1,0.7l2-0.6c0.3-0.1,0.8-0.9,0.7-1.2l-0.8-2.4c0-0.1-0.1-0.3-0.2-0.5l-0.3-1C390.1-23.6,389.6-24,389.4-23.9z
				" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_34_"
              cx="485.9456"
              cy="27.0971"
              r="8.7834"
              gradientTransform="matrix(0.9067 0.4218 -0.4218 0.9067 54.1484 -246.1999)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst39" cx="483.3" cy="-16.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M485.1-12.7c-0.9,1.9-3.5,2.7-4.6,2.2c-1.2-0.6-2.3-3.1-1.4-5c0.9-1.9,4.3-5.8,6-5
				C486.8-19.7,486-14.6,485.1-12.7z" />
              <path
                class="cst5"
                d="M482.3-11.1l-2.6-1.2c-0.3-0.1-0.7,0.3-0.8,0.6l-0.4,1c-0.1,0.2-0.2,0.4-0.2,0.5L477.1-8
				c-0.1,0.3,0.1,1.1,0.4,1.3l1.9,0.9c0.3,0.1,1.2-0.2,1.3-0.5l1.1-2.3c0-0.1,0.1-0.3,0.2-0.5l0.4-1C482.6-10.3,482.6-11,482.3-11.1
				z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_35_"
              cx="571.7973"
              cy="21.5746"
              r="8.7835"
              gradientTransform="matrix(0.9621 0.2727 -0.2727 0.9621 18.8833 -162.4197)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst40" cx="563.1" cy="14.3" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M565.5,17.9c-0.6,2-3,3.3-4.2,2.9c-1.3-0.4-2.7-2.7-2.2-4.7c0.6-2,3.3-6.4,5.1-5.9
				C566,10.7,566.1,15.9,565.5,17.9z" />
              <path
                class="cst5"
                d="M563,19.9l-2.8-0.8c-0.3-0.1-0.6,0.4-0.7,0.7l-0.3,1c-0.1,0.2-0.1,0.4-0.1,0.5l-0.7,2.5
				c-0.1,0.3,0.3,1.1,0.6,1.2l2,0.6c0.3,0.1,1.2-0.4,1.2-0.7l0.7-2.5c0-0.1,0.1-0.3,0.1-0.5l0.3-1C563.4,20.6,563.3,20,563,19.9z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_36_"
              cx="646.582"
              cy="-2.3606"
              r="8.7838"
              gradientTransform="matrix(0.9834 -0.1812 0.1812 0.9834 4.096 138.7198)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst41" cx="639.5" cy="19.2" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M643.3,21.4c0.4,2-1.2,4.2-2.5,4.5c-1.3,0.2-3.7-1.2-4-3.3c-0.4-2,0.2-7.2,2-7.5
				C640.6,14.8,642.9,19.4,643.3,21.4z" />
              <path
                class="cst5"
                d="M641.9,24.4l-2.8,0.5c-0.3,0.1-0.4,0.7-0.3,1l0.2,1c0,0.2,0.1,0.5,0.1,0.5l0.5,2.5c0.1,0.3,0.8,0.9,1.1,0.8
				l2.1-0.4c0.3-0.1,0.9-0.8,0.8-1.1l-0.5-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.2-1C642.6,24.8,642.2,24.3,641.9,24.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_37_"
              cx="715.0056"
              cy="-14.0322"
              r="8.7835"
              gradientTransform="matrix(0.8869 -0.462 0.462 0.8869 77.4847 338.1451)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst42" cx="705.1" cy="-4.6" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M709.4-3.6c1,1.8,0.1,4.4-1.1,5c-1.2,0.6-3.9-0.1-4.8-1.9c-1-1.8-1.9-6.9-0.3-7.8
				C704.8-9.2,708.4-5.5,709.4-3.6z" />
              <path
                class="cst5"
                d="M708.9-0.4l-2.5,1.3c-0.3,0.1-0.2,0.7,0,1l0.5,0.9c0.1,0.2,0.2,0.4,0.2,0.5l1.2,2.3c0.1,0.3,1,0.6,1.2,0.5
				l1.9-1c0.3-0.1,0.6-1.1,0.4-1.3l-1.2-2.3c0-0.1-0.1-0.2-0.2-0.5l-0.5-0.9C709.7-0.2,709.2-0.6,708.9-0.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_38_"
              cx="780.7552"
              cy="-13.4833"
              r="8.7833"
              gradientTransform="matrix(0.9998 2.170000e-02 -2.170000e-02 0.9998 -16.1035 -35.2458)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst43" cx="764.8" cy="-31.8" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M768-28.9c0,2.1-2.1,3.9-3.3,3.9c-1.3,0-3.3-2-3.3-4c0-2.1,1.6-7,3.5-7C766.7-35.9,768.1-30.9,768-28.9z" />
              <path
                class="cst5"
                d="M766.1-26.3l-2.9-0.1c-0.3,0-0.5,0.6-0.5,0.9l0,1.1c0,0.2,0,0.5,0,0.5l-0.1,2.6c0,0.3,0.6,1,0.9,1l2.1,0
				c0.3,0,1-0.6,1-1l0.1-2.6c0-0.1,0-0.3,0-0.5l0-1.1C766.7-25.7,766.4-26.3,766.1-26.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_39_"
              cx="806.1928"
              cy="2.5494"
              r="8.7839"
              gradientTransform="matrix(-5.230000e-02 0.9986 -0.9986 -5.230000e-02 838.808 -804.3041)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst44" cx="794.1" cy="0.6" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M791.1,3.8c-2.1-0.1-3.8-2.2-3.8-3.5c0.1-1.3,2.1-3.3,4.1-3.2c2.1,0.1,7,1.8,6.9,3.7
				C798.2,2.7,793.1,3.9,791.1,3.8z" />
              <path
                class="cst5"
                d="M788.6,1.8l0.1-2.9c0-0.3-0.5-0.5-0.9-0.5l-1-0.1c-0.2,0-0.5,0-0.5,0l-2.6-0.1c-0.3,0-1,0.5-1,0.8l-0.1,2.1
				c0,0.3,0.6,1,0.9,1.1l2.6,0.1c0.1,0,0.3,0,0.5,0l1.1,0.1C788,2.3,788.5,2.1,788.6,1.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_40_"
              cx="845.484"
              cy="17.5076"
              r="8.7831"
              gradientTransform="matrix(-0.6718 -0.7408 0.7408 -0.6718 1314.7922 653.5539)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst45" cx="759.8" cy="15.5" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M759.6,11.1c1.5-1.4,4.3-1.2,5.1-0.2c0.9,1,0.9,3.8-0.7,5.1c-1.5,1.4-6.2,3.6-7.4,2.3
				C755.4,16.9,758.1,12.5,759.6,11.1z" />
              <path
                class="cst5"
                d="M762.9,10.7l1.9,2.1c0.2,0.2,0.8,0,1-0.2l0.8-0.7c0.2-0.2,0.3-0.3,0.4-0.4l1.9-1.7c0.2-0.2,0.3-1.1,0.1-1.3
				L767.6,7c-0.2-0.2-1.2-0.3-1.4-0.1l-1.9,1.7c-0.1,0-0.2,0.2-0.4,0.4l-0.8,0.7C762.9,9.9,762.7,10.5,762.9,10.7z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_41_"
              cx="864.4544"
              cy="69.8088"
              r="8.7836"
              gradientTransform="matrix(0.9706 -0.2406 0.2406 0.9706 -61.3987 110.4873)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst46" cx="794.4" cy="-29.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M798.3-27.8c0.5,2-1,4.3-2.2,4.6c-1.3,0.3-3.7-1-4.2-3c-0.5-2-0.3-7.2,1.5-7.6
				C795.2-34.3,797.8-29.8,798.3-27.8z" />
              <path
                class="cst5"
                d="M797.1-24.8l-2.8,0.7c-0.3,0.1-0.3,0.7-0.3,1l0.3,1c0.1,0.2,0.1,0.4,0.1,0.5l0.6,2.5
				c0.1,0.3,0.8,0.8,1.1,0.7l2-0.5c0.3-0.1,0.8-0.9,0.7-1.2l-0.6-2.5c0-0.1-0.1-0.3-0.1-0.5l-0.3-1
				C797.9-24.4,797.4-24.9,797.1-24.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_42_"
              cx="57.4555"
              cy="61.0163"
              r="8.7832"
              gradientTransform="matrix(-0.8752 0.4838 -0.4838 -0.8752 123.2143 28.3373)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst47" cx="43.4" cy="2.7" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M39.1,1.9c-1-1.8-0.2-4.4,0.9-5c1.2-0.6,3.9,0,4.9,1.8c1,1.8,2.1,6.9,0.5,7.8C43.8,7.3,40.1,3.7,39.1,1.9z" />
              <path
                class="cst5"
                d="M39.5-1.4L42-2.8c0.3-0.1,0.2-0.7,0-1l-0.5-0.9c-0.1-0.2-0.2-0.4-0.3-0.5l-1.2-2.2c-0.1-0.3-1-0.6-1.3-0.4
				l-1.8,1c-0.3,0.1-0.6,1.1-0.4,1.3l1.2,2.2c0,0.1,0.1,0.2,0.3,0.5l0.5,0.9C38.7-1.6,39.3-1.2,39.5-1.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_43_"
              cx="9.065"
              cy="46.1228"
              r="8.7831"
              gradientTransform="matrix(-0.9923 -0.1242 0.1242 -0.9923 95.8603 38.7832)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst48" cx="92.6" cy="-8.1" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M89.7-11.3c0.3-2,2.5-3.7,3.7-3.5c1.3,0.2,3.1,2.3,2.9,4.3c-0.3,2-2.3,6.8-4.2,6.6
				C90.3-4.2,89.4-9.3,89.7-11.3z" />
              <path
                class="cst5"
                d="M91.9-13.7l2.8,0.4c0.3,0,0.6-0.5,0.6-0.8l0.1-1c0-0.2,0.1-0.5,0.1-0.5l0.3-2.5c0-0.3-0.5-1-0.8-1.1L93-19.6
				c-0.3,0-1.1,0.5-1.1,0.8l-0.3,2.5c0,0.1,0,0.3-0.1,0.5l-0.1,1C91.3-14.4,91.6-13.7,91.9-13.7z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_44_"
              cx="-50.4849"
              cy="30.0675"
              r="8.7834"
              gradientTransform="matrix(-0.8707 -0.4918 0.4918 -0.8707 91.3561 17.078)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst49" cx="150.1" cy="15.7" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M148.6,11.6c1-1.8,3.7-2.5,4.8-1.8c1.2,0.7,2,3.3,1,5.1c-1,1.8-4.8,5.4-6.3,4.5
				C146.4,18.5,147.6,13.4,148.6,11.6z" />
              <path
                class="cst5"
                d="M151.6,10.3l2.5,1.4c0.3,0.2,0.7-0.3,0.9-0.5l0.5-0.9c0.1-0.2,0.2-0.4,0.3-0.5l1.3-2.2
				c0.2-0.3,0-1.1-0.3-1.3l-1.8-1c-0.3-0.1-1.2,0.1-1.4,0.4l-1.3,2.2c0,0.1-0.1,0.2-0.3,0.5l-0.5,0.9
				C151.3,9.5,151.3,10.1,151.6,10.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_45_"
              cx="-126.2008"
              cy="40.9624"
              r="8.7837"
              gradientTransform="matrix(-0.9931 -0.117 0.117 -0.9931 91.4809 68.8053)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst50" cx="221.6" cy="42.9" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M218.6,39.7c0.2-2,2.4-3.7,3.7-3.5c1.3,0.2,3.1,2.3,2.9,4.3c-0.2,2-2.3,6.8-4.1,6.6
				C219.3,46.9,218.4,41.7,218.6,39.7z" />
              <path
                class="cst5"
                d="M220.8,37.3l2.9,0.3c0.3,0,0.6-0.5,0.6-0.8l0.1-1c0-0.2,0.1-0.5,0.1-0.5l0.3-2.5c0-0.3-0.5-1-0.8-1.1
				l-2.1-0.2c-0.3,0-1.1,0.5-1.1,0.9l-0.3,2.5c0,0.1,0,0.3-0.1,0.5l-0.1,1C220.3,36.7,220.5,37.3,220.8,37.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_46_"
              cx="-199.4359"
              cy="69.4943"
              r="8.7831"
              gradientTransform="matrix(-0.9269 0.3754 -0.3754 -0.9269 140.4957 171.0848)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst51" cx="299.3" cy="31.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M295.1,30.4c-0.8-1.9,0.4-4.4,1.5-4.9c1.2-0.5,3.8,0.5,4.6,2.4c0.8,1.9,1.3,7.1-0.4,7.8
				C299.1,36.4,295.9,32.3,295.1,30.4z" />
              <path
                class="cst5"
                d="M295.9,27.3l2.7-1.1c0.3-0.1,0.3-0.7,0.1-1l-0.4-1c-0.1-0.2-0.2-0.4-0.2-0.5l-1-2.4
				c-0.1-0.3-0.9-0.7-1.2-0.6l-1.9,0.8c-0.3,0.1-0.7,1-0.6,1.3l1,2.4c0,0.1,0.1,0.3,0.2,0.5l0.4,1C295.1,27,295.6,27.4,295.9,27.3z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_47_"
              cx="-268.8126"
              cy="71.0208"
              r="8.7834"
              gradientTransform="matrix(-0.9099 0.4148 -0.4148 -0.9099 148.1842 180.9048)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst52" cx="363.3" cy="4.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M359.1,3.6c-0.9-1.9,0.2-4.4,1.3-4.9c1.2-0.5,3.9,0.3,4.7,2.2c0.9,1.9,1.6,7-0.1,7.8
				C363.4,9.4,360,5.4,359.1,3.6z" />
              <path
                class="cst5"
                d="M359.8,0.4l2.6-1.2c0.3-0.1,0.2-0.7,0.1-1l-0.4-1c-0.1-0.2-0.2-0.4-0.2-0.5l-1.1-2.3
				c-0.1-0.3-0.9-0.6-1.2-0.5l-1.9,0.9c-0.3,0.1-0.6,1-0.5,1.3l1.1,2.3c0,0.1,0.1,0.3,0.2,0.5l0.4,1C359,0.1,359.5,0.5,359.8,0.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_48_"
              cx="-341.5268"
              cy="53.7822"
              r="8.7838"
              gradientTransform="matrix(-0.9826 -0.1855 0.1855 -0.9826 89.9502 -19.6301)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst53" cx="435.5" cy="-9.1" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M432.8-12.5c0.4-2,2.7-3.5,3.9-3.3c1.3,0.2,3,2.5,2.6,4.5c-0.4,2-2.8,6.6-4.6,6.3
				C432.9-5.3,432.4-10.5,432.8-12.5z" />
              <path
                class="cst5"
                d="M435.1-14.8l2.8,0.5c0.3,0.1,0.6-0.5,0.7-0.8l0.2-1c0-0.2,0.1-0.4,0.1-0.5l0.5-2.5c0.1-0.3-0.4-1.1-0.7-1.1
				l-2.1-0.4c-0.3-0.1-1.1,0.5-1.2,0.8l-0.5,2.5c0,0.1-0.1,0.3-0.1,0.5l-0.2,1C434.6-15.4,434.8-14.8,435.1-14.8z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_49_"
              cx="-423.2584"
              cy="36.5655"
              r="8.7834"
              gradientTransform="matrix(-0.9265 -0.3763 0.3763 -0.9265 107.3465 -104.5927)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst54" cx="513.3" cy="20.8" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M511.3,16.9c0.8-1.9,3.3-2.9,4.5-2.4c1.2,0.5,2.4,3,1.6,4.9c-0.8,1.9-4,6-5.7,5.3
				C510,24,510.5,18.8,511.3,16.9z" />
              <path
                class="cst5"
                d="M514,15.2l2.7,1.1c0.3,0.1,0.7-0.3,0.8-0.6l0.4-1c0.1-0.2,0.2-0.4,0.2-0.5l1-2.4c0.1-0.3-0.2-1.1-0.5-1.2
				l-1.9-0.8c-0.3-0.1-1.2,0.2-1.3,0.5l-1,2.4c0,0.1-0.1,0.3-0.2,0.5l-0.4,1C513.6,14.4,513.7,15.1,514,15.2z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_50_"
              cx="-514.5245"
              cy="49.5535"
              r="8.7839"
              gradientTransform="matrix(-0.9995 -3.020000e-02 3.020000e-02 -0.9995 86.9557 77.8894)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst55" cx="602.7" cy="43.9" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M599.5,41c0.1-2.1,2.1-3.9,3.4-3.8c1.3,0,3.3,2,3.2,4c-0.1,2.1-1.7,7-3.5,6.9C600.8,48,599.4,43,599.5,41z" />
              <path
                class="cst5"
                d="M601.5,38.4l2.9,0.1c0.3,0,0.5-0.6,0.5-0.9l0-1c0-0.2,0-0.5,0-0.5l0.1-2.6c0-0.3-0.6-1-0.9-1l-2.1-0.1
				c-0.3,0-1,0.6-1,0.9l-0.1,2.6c0,0.1,0,0.3,0,0.5l0,1C600.9,37.8,601.2,38.4,601.5,38.4z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_51_"
              cx="-593.5144"
              cy="64.133"
              r="8.7833"
              gradientTransform="matrix(-0.9414 0.3374 -0.3374 -0.9414 145.1165 291.4482)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst56" cx="682.2" cy="30.8" r="8.8" />
            <g>
              <path
                class="cst34"
                d="M678.1,29.3c-0.7-1.9,0.5-4.4,1.7-4.8c1.2-0.4,3.8,0.6,4.5,2.6c0.7,1.9,1,7.1-0.7,7.7
				C681.9,35.4,678.8,31.2,678.1,29.3z" />
              <path
                class="cst5"
                d="M679,26.2l2.7-1c0.3-0.1,0.3-0.7,0.2-1l-0.4-1c-0.1-0.2-0.2-0.4-0.2-0.5l-0.9-2.4c-0.1-0.3-0.9-0.7-1.2-0.6
				l-2,0.7c-0.3,0.1-0.7,1-0.6,1.3l0.9,2.4c0,0.1,0.1,0.3,0.2,0.5l0.4,1C678.3,25.8,678.8,26.3,679,26.2z" />
            </g>
          </g>
          <g class="cst2">
            <radialGradient
              id="CSVGID_52_"
              cx="-661.9906"
              cy="72.7947"
              r="8.7839"
              gradientTransform="matrix(-0.8713 0.4907 -0.4907 -0.8713 203.3462 387.9924)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                " />
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                " />
            </radialGradient>
            <circle class="cst57" cx="744.4" cy="-0.3" r="8.8" />
            <g>
              <path
                class="cst4"
                d="M740.1-1.1c-1-1.8-0.2-4.4,0.9-5c1.2-0.7,3.9,0,4.9,1.8c1,1.8,2.2,6.9,0.6,7.8
				C744.9,4.3,741.1,0.7,740.1-1.1z" />
              <path
                class="cst5"
                d="M740.5-4.3l2.5-1.4c0.3-0.1,0.2-0.7,0-1l-0.5-0.9c-0.1-0.2-0.2-0.4-0.3-0.5l-1.3-2.2c-0.2-0.3-1-0.6-1.3-0.4
				l-1.8,1c-0.3,0.2-0.5,1.1-0.4,1.3l1.3,2.2c0,0.1,0.1,0.2,0.3,0.5l0.5,0.9C739.7-4.5,740.2-4.2,740.5-4.3z" />
            </g>
          </g>
        </g>
        <path
          class="cst58"
          d="M0.2,5.3c7,1.7,13,8.1,21,8.1c12.6-0.1,21.2-8.7,29.7-8.8s17.8,8.5,30.5,8.9c8.8,0.3,15.4-3.5,19.9-6.2
	c1.2-0.7,9-6.3,18.6-0.5c23.6,16.6,31.7-1.8,45.3-2c10,0.1,9.9,5.8,24.6,7" />
        <radialGradient
          id="CSVGID_53_"
          cx="-1971.8351"
          cy="-547.2614"
          r="8.7832"
          gradientTransform="matrix(0.1746 8.075637e-02 -8.075632e-02 0.1746 304.9496 259.4695)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst59" cx="5" cy="4.7" r="1.7" />
        <path
          class="cst60"
          d="M5.3,5.5C5.1,5.8,4.6,6,4.4,5.9C4.2,5.8,4,5.3,4.1,4.9C4.3,4.6,5,3.8,5.3,4C5.6,4.1,5.5,5.1,5.3,5.5z" />
        <path
          class="cst5"
          d="M4.8,5.8L4.3,5.5c-0.1,0-0.1,0.1-0.2,0.1L4,5.8c0,0,0,0.1,0,0.1L3.8,6.4c0,0.1,0,0.2,0.1,0.2l0.4,0.2
	c0.1,0,0.2,0,0.3-0.1l0.2-0.4c0,0,0,0,0-0.1L4.8,6C4.8,5.9,4.8,5.8,4.8,5.8z" />
        <radialGradient
          id="CSVGID_54_"
          cx="-1860.7815"
          cy="-715.9463"
          r="8.7832"
          gradientTransform="matrix(0.179 7.049398e-02 -7.055520e-02 0.1789 298.8928 269.5952)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst61" cx="16.3" cy="10.4" r="1.7" />
        <path
          class="cst60"
          d="M16.7,11.1c-0.1,0.4-0.6,0.6-0.9,0.5c-0.2-0.1-0.5-0.6-0.3-0.9c0.1-0.4,0.8-1.2,1.1-1
	C17,9.7,16.9,10.7,16.7,11.1z" />
        <path
          class="cst5"
          d="M16.2,11.4l-0.5-0.2c-0.1,0-0.1,0.1-0.2,0.1l-0.1,0.2c0,0,0,0.1,0,0.1l-0.2,0.5c0,0.1,0,0.2,0.1,0.2l0.4,0.1
	c0.1,0,0.2,0,0.2-0.1l0.2-0.5c0,0,0-0.1,0-0.1l0.1-0.2C16.3,11.6,16.3,11.5,16.2,11.4z" />
        <radialGradient
          id="CSVGID_55_"
          cx="-1079.3364"
          cy="-1728.5146"
          r="8.7833"
          gradientTransform="matrix(0.1881 -4.013778e-02 4.013776e-02 0.1881 300.4198 291.9852)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst62" cx="28" cy="10.2" r="1.7" />
        <path
          class="cst60"
          d="M28.8,10.6c0.1,0.4-0.2,0.8-0.5,0.9c-0.2,0.1-0.7-0.2-0.8-0.6c-0.1-0.4,0-1.4,0.3-1.5
	C28.2,9.3,28.7,10.2,28.8,10.6z" />
        <path
          class="cst5"
          d="M28.5,11.2L28,11.3c-0.1,0-0.1,0.1-0.1,0.2l0,0.2c0,0,0,0.1,0,0.1l0.1,0.5c0,0.1,0.1,0.2,0.2,0.1l0.4-0.1
	c0.1,0,0.2-0.2,0.2-0.2l-0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C28.7,11.2,28.6,11.1,28.5,11.2z" />
        <radialGradient
          id="CSVGID_56_"
          cx="-781.3234"
          cy="-1896.4077"
          r="8.7832"
          gradientTransform="matrix(0.1815 -6.375504e-02 6.375499e-02 0.1815 302.5989 299.8094)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst63" cx="39.9" cy="5.5" r="1.7" />
        <path
          class="cst60"
          d="M40.7,5.8c0.1,0.4-0.1,0.8-0.3,0.9c-0.2,0.1-0.7-0.1-0.9-0.5c-0.1-0.4-0.2-1.4,0.2-1.5
	C40,4.6,40.6,5.4,40.7,5.8z" />
        <path
          class="cst5"
          d="M40.5,6.4L40,6.6c-0.1,0-0.1,0.1,0,0.2L40,7c0,0,0,0.1,0,0.1l0.2,0.5c0,0.1,0.2,0.1,0.2,0.1l0.4-0.1
	c0.1,0,0.1-0.2,0.1-0.2l-0.2-0.5c0,0,0-0.1,0-0.1l-0.1-0.2C40.7,6.5,40.6,6.4,40.5,6.4z" />
        <radialGradient
          id="CSVGID_57_"
          cx="-1826.2764"
          cy="-564.0766"
          r="8.7832"
          gradientTransform="matrix(0.1864 4.709109e-02 -4.724856e-02 0.1864 369.0383 193.9668)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst64" cx="55.2" cy="2.8" r="1.7" />
        <path
          class="cst60"
          d="M55.7,3.5c-0.1,0.4-0.6,0.6-0.8,0.6c-0.2-0.1-0.5-0.5-0.4-0.9c0.1-0.4,0.6-1.2,1-1.2
	C55.8,2.1,55.8,3.1,55.7,3.5z" />
        <path
          class="cst5"
          d="M55.2,3.9l-0.5-0.1c-0.1,0-0.1,0.1-0.1,0.1l0,0.2c0,0,0,0.1,0,0.1l-0.1,0.5c0,0.1,0.1,0.2,0.1,0.2L54.9,5
	c0.1,0,0.2-0.1,0.2-0.1l0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C55.3,4.1,55.3,3.9,55.2,3.9z" />
        <radialGradient
          id="CSVGID_58_"
          cx="-1623.8353"
          cy="-524.1362"
          r="8.7834"
          gradientTransform="matrix(0.1744 8.112179e-02 -8.112174e-02 0.1744 310.27 231.6793)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst65" cx="69.6" cy="8.6" r="1.7" />
        <path
          class="cst60"
          d="M70,9.3c-0.2,0.4-0.7,0.5-0.9,0.4c-0.2-0.1-0.4-0.6-0.3-1c0.2-0.4,0.8-1.1,1.1-1C70.3,8,70.1,9,70,9.3z" />
        <path
          class="cst5"
          d="M69.4,9.6l-0.5-0.2c-0.1,0-0.1,0.1-0.2,0.1l-0.1,0.2c0,0,0,0.1,0,0.1l-0.2,0.4c0,0.1,0,0.2,0.1,0.2l0.4,0.2
	c0.1,0,0.2,0,0.3-0.1l0.2-0.4c0,0,0,0,0-0.1l0.1-0.2C69.5,9.8,69.5,9.6,69.4,9.6z" />
        <radialGradient
          id="CSVGID_59_"
          cx="-557.0599"
          cy="-2060.3057"
          r="8.7835"
          gradientTransform="matrix(0.1882 -3.976264e-02 3.976899e-02 0.1882 274.578 376.2189)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst66" cx="87.8" cy="10.7" r="1.7" />
        <path
          class="cst60"
          d="M88.6,11.1c0.1,0.4-0.2,0.8-0.5,0.9c-0.2,0.1-0.7-0.2-0.8-0.6c-0.1-0.4,0-1.4,0.3-1.5
	C88,9.8,88.5,10.7,88.6,11.1z" />
        <path
          class="cst5"
          d="M88.3,11.7l-0.5,0.1c-0.1,0-0.1,0.1-0.1,0.2l0,0.2c0,0,0,0.1,0,0.1l0.1,0.5c0,0.1,0.1,0.2,0.2,0.1l0.4-0.1
	c0.1,0,0.2-0.2,0.2-0.2l-0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C88.4,11.7,88.4,11.7,88.3,11.7z" />
        <radialGradient
          id="CSVGID_60_"
          cx="-301.4189"
          cy="-2051.4839"
          r="8.7838"
          gradientTransform="matrix(0.1798 -6.832683e-02 6.832670e-02 0.1798 294.5162 353.6536)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst67" cx="100.2" cy="5.5" r="1.7" />
        <path
          class="cst60"
          d="M100.9,5.7c0.1,0.4-0.1,0.8-0.3,0.9c-0.2,0.1-0.7-0.1-0.9-0.5c-0.1-0.4-0.2-1.4,0.1-1.5
	C100.2,4.6,100.8,5.4,100.9,5.7z" />
        <path
          class="cst5"
          d="M100.8,6.3l-0.5,0.2c-0.1,0-0.1,0.1,0,0.2l0.1,0.2c0,0,0,0.1,0,0.1l0.2,0.5c0,0.1,0.2,0.1,0.2,0.1l0.4-0.1
	c0.1,0,0.1-0.2,0.1-0.2l-0.2-0.5c0,0,0-0.1,0-0.1L101,6.5C100.9,6.4,100.8,6.3,100.8,6.3z" />
        <radialGradient
          id="CSVGID_61_"
          cx="-1436.9215"
          cy="-844.0944"
          r="8.7835"
          gradientTransform="matrix(0.1914 2.199848e-02 -2.193136e-02 0.191 370.8778 195.0811)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst68"
          d="M116,2.5c-0.1,0.9-0.9,1.6-1.9,1.5c-0.9-0.1-1.6-0.9-1.5-1.9c0.1-0.9,0.9-1.6,1.9-1.5
	C115.5,0.7,116.1,1.5,116,2.5z" />
        <path
          class="cst60"
          d="M114.9,2.9c0,0.4-0.5,0.7-0.7,0.7c-0.3,0-0.6-0.4-0.6-0.8c0-0.4,0.4-1.3,0.8-1.3C114.8,1.5,115,2.5,114.9,2.9z
	" />
        <path
          class="cst5"
          d="M114.5,3.3l-0.5-0.1c-0.1,0-0.1,0.1-0.1,0.2l0,0.2c0,0,0,0.1,0,0.1l-0.1,0.5c0,0.1,0.1,0.2,0.1,0.2l0.4,0
	c0.1,0,0.2-0.1,0.2-0.2l0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C114.6,3.5,114.5,3.3,114.5,3.3z" />
        <radialGradient
          id="CSVGID_62_"
          cx="2090.8032"
          cy="436.2058"
          r="8.7834"
          gradientTransform="matrix(-0.1675 -9.458439e-02 9.458433e-02 -0.1675 317.4259 282.3137)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst69" cx="8.6" cy="11.5" r="1.7" />
        <path
          class="cst70"
          d="M8.3,10.7c0.2-0.3,0.7-0.5,0.9-0.4c0.2,0.1,0.4,0.6,0.2,1c-0.2,0.3-0.9,1-1.2,0.9C7.9,12,8.1,11.1,8.3,10.7z" />
        <path
          class="cst5"
          d="M8.8,10.5l0.5,0.3c0.1,0,0.1,0,0.2-0.1l0.1-0.2c0,0,0-0.1,0-0.1l0.2-0.4c0-0.1,0-0.2-0.1-0.2L9.5,9.5
	c-0.1,0-0.2,0-0.3,0.1L9,10c0,0,0,0,0,0.1l-0.1,0.2C8.8,10.3,8.8,10.4,8.8,10.5z" />
        <radialGradient
          id="CSVGID_63_"
          cx="1547.8306"
          cy="1467.0818"
          r="8.7837"
          gradientTransform="matrix(-0.1922 -5.992205e-03 5.992180e-03 -0.1922 311.0797 306.8308)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst71" cx="22.3" cy="15.5" r="1.7" />
        <path
          class="cst70"
          d="M21.7,15c0-0.4,0.4-0.7,0.7-0.7c0.3,0,0.6,0.4,0.6,0.8c0,0.4-0.3,1.3-0.7,1.3C22,16.3,21.7,15.4,21.7,15z" />
        <path
          class="cst5"
          d="M22.1,14.5l0.6,0c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l0-0.5c0-0.1-0.1-0.2-0.2-0.2l-0.4,0
	c-0.1,0-0.2,0.1-0.2,0.2l0,0.5c0,0,0,0.1,0,0.1l0,0.2C22,14.4,22,14.5,22.1,14.5z" />
        <radialGradient
          id="CSVGID_64_"
          cx="819.5911"
          cy="2012.6837"
          r="8.7831"
          gradientTransform="matrix(-0.1783 7.219800e-02 -7.219796e-02 -0.1783 326.8766 311.9327)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst72" cx="35.5" cy="12.3" r="1.7" />
        <path
          class="cst70"
          d="M34.7,12c-0.1-0.4,0.1-0.8,0.3-0.9c0.2-0.1,0.7,0.1,0.9,0.5c0.1,0.4,0.2,1.4-0.1,1.5
	C35.4,13.2,34.8,12.4,34.7,12z" />
        <path
          class="cst5"
          d="M34.8,11.4l0.5-0.2c0.1,0,0-0.1,0-0.2l-0.1-0.2c0,0,0-0.1,0-0.1l-0.2-0.5c0-0.1-0.2-0.1-0.2-0.1l-0.4,0.2
	c-0.1,0-0.1,0.2-0.1,0.2l0.2,0.5c0,0,0,0.1,0,0.1l0.1,0.2C34.7,11.4,34.8,11.5,34.8,11.4z" />
        <radialGradient
          id="CSVGID_65_"
          cx="1433.5469"
          cy="1493.1055"
          r="8.7834"
          gradientTransform="matrix(-0.1906 2.239874e-02 -2.226182e-02 -0.1912 354.1053 260.5801)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst73"
          d="M45.9,7.4c-0.1-0.9,0.6-1.8,1.5-1.9c0.9-0.1,1.8,0.6,1.9,1.5c0.1,0.9-0.6,1.8-1.5,1.9C46.9,9,46,8.3,45.9,7.4z
	" />
        <path
          class="cst70"
          d="M46.9,6.7c0-0.4,0.3-0.8,0.5-0.8c0.3,0,0.7,0.3,0.7,0.7C48.2,7,48,8,47.7,8C47.3,8.1,47,7.1,46.9,6.7z" />
        <path
          class="cst5"
          d="M47.2,6.2l0.5-0.1c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l-0.1-0.5c0-0.1-0.1-0.2-0.2-0.2l-0.4,0
	C47.1,5,47,5.2,47,5.2L47,5.7c0,0,0,0.1,0,0.1l0,0.2C47.1,6.1,47.2,6.2,47.2,6.2z" />
        <radialGradient
          id="CSVGID_66_"
          cx="1562.6237"
          cy="1110.0529"
          r="8.7838"
          gradientTransform="matrix(-0.189 -3.567589e-02 3.567587e-02 -0.189 317.1555 275.2539)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst74" cx="61.5" cy="9.7" r="1.7" />
        <path
          class="cst70"
          d="M60.9,9.1c0.1-0.4,0.5-0.7,0.8-0.6c0.3,0,0.6,0.5,0.5,0.9c-0.1,0.4-0.5,1.3-0.9,1.2C61,10.5,60.9,9.5,60.9,9.1
	z" />
        <path
          class="cst5"
          d="M61.4,8.6l0.5,0.1c0.1,0,0.1-0.1,0.1-0.1l0-0.2c0,0,0-0.1,0-0.1l0.1-0.5c0-0.1-0.1-0.2-0.1-0.2l-0.4-0.1
	c-0.1,0-0.2,0.1-0.2,0.1l-0.1,0.5c0,0,0,0.1,0,0.1l0,0.2C61.3,8.5,61.3,8.6,61.4,8.6z" />
        <radialGradient
          id="CSVGID_67_"
          cx="1229.8514"
          cy="1599.9799"
          r="8.7834"
          gradientTransform="matrix(-0.192 -1.156983e-02 1.157245e-02 -0.192 294.2471 336.4446)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst75" cx="76.7" cy="15.1" r="1.7" />
        <path
          class="cst70"
          d="M76.1,14.5c0-0.4,0.4-0.7,0.7-0.7c0.3,0,0.6,0.4,0.6,0.8c0,0.4-0.4,1.3-0.7,1.3C76.3,15.9,76,14.9,76.1,14.5z" />
        <path
          class="cst5"
          d="M76.5,14l0.6,0c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l0-0.5c0-0.1-0.1-0.2-0.2-0.2l-0.4,0
	c-0.1,0-0.2,0.1-0.2,0.2l0,0.5c0,0,0,0.1,0,0.1l0,0.2C76.3,13.9,76.4,14,76.5,14z" />
        <radialGradient
          id="CSVGID_68_"
          cx="606.3625"
          cy="2019.9858"
          r="8.7839"
          gradientTransform="matrix(-0.1861 4.792444e-02 -4.716231e-02 -0.1858 303.8452 358.9221)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst76"
          d="M94.1,13.1c-0.2-0.9,0.3-1.8,1.2-2.1c0.9-0.2,1.8,0.3,2,1.2c0.2,0.9-0.3,1.8-1.2,2.1
	C95.2,14.5,94.3,14,94.1,13.1z" />
        <path
          class="cst70"
          d="M95,12.3c-0.1-0.4,0.2-0.8,0.4-0.9c0.2-0.1,0.7,0.2,0.8,0.6c0.1,0.4,0.1,1.4-0.3,1.5
	C95.6,13.5,95.1,12.6,95,12.3z" />
        <path
          class="cst5"
          d="M95.2,11.7l0.5-0.1c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l-0.1-0.5c0-0.1-0.2-0.2-0.2-0.1L95,10.5
	c-0.1,0-0.2,0.2-0.1,0.2l0.1,0.5c0,0,0,0.1,0,0.1l0,0.2C95.1,11.6,95.2,11.7,95.2,11.7z" />
        <radialGradient
          id="CSVGID_69_"
          cx="877.1065"
          cy="1662.433"
          r="8.7833"
          gradientTransform="matrix(-0.1889 3.610808e-02 -3.610665e-02 -0.1889 333.2144 289.1466)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst77" cx="107.5" cy="6.8" r="1.7" />
        <path
          class="cst70"
          d="M106.8,6.4c-0.1-0.4,0.2-0.8,0.5-0.9c0.3,0,0.7,0.2,0.8,0.6c0.1,0.4,0,1.4-0.4,1.5
	C107.3,7.6,106.8,6.7,106.8,6.4z" />
        <path
          class="cst5"
          d="M107,5.8l0.5-0.1c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l-0.1-0.5c0-0.1-0.1-0.2-0.2-0.2l-0.4,0.1
	c-0.1,0-0.2,0.2-0.2,0.2l0.1,0.5c0,0,0,0.1,0,0.1l0,0.2C106.9,5.7,107,5.8,107,5.8z" />
        <radialGradient
          id="CSVGID_70_"
          cx="-1626.3575"
          cy="1220.9843"
          r="8.7838"
          gradientTransform="matrix(0.1685 9.277516e-02 9.276192e-02 -0.1685 280.2799 365.8498)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst78" cx="119.6" cy="9.2" r="1.7" />
        <path
          class="cst70"
          d="M120.4,9c0.2-0.3,0-0.9-0.2-1c-0.2-0.1-0.7,0-0.9,0.4c-0.2,0.3-0.4,1.3-0.1,1.5C119.5,10,120.2,9.3,120.4,9z" />
        <path
          class="cst5"
          d="M120.3,8.4l-0.5-0.3c-0.1,0,0-0.1,0-0.2l0.1-0.2c0,0,0-0.1,0-0.1l0.2-0.4c0-0.1,0.2-0.1,0.2-0.1l0.4,0.2
	c0.1,0,0.1,0.2,0.1,0.3L120.7,8c0,0,0,0,0,0.1l-0.1,0.2C120.5,8.3,120.4,8.4,120.3,8.4z" />
        <radialGradient
          id="CSVGID_71_"
          cx="4516.7578"
          cy="-696.6927"
          r="8.7835"
          gradientTransform="matrix(-0.1783 -7.005322e-02 -7.071184e-02 0.1788 883.5137 449.8008)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst79"
          d="M126.1,8.2c-0.3,0.9,0.1,1.8,0.9,2.2c0.9,0.3,1.8-0.1,2.2-1c0.3-0.9-0.1-1.8-0.9-2.2
	C127.4,6.9,126.4,7.3,126.1,8.2z" />
        <path
          class="cst60"
          d="M126.9,9.1c-0.1,0.4,0.1,0.8,0.3,0.9c0.2,0.1,0.7-0.1,0.9-0.5c0.1-0.4,0.2-1.4-0.1-1.5
	C127.6,7.9,127,8.7,126.9,9.1z" />
        <path
          class="cst5"
          d="M127,9.7l0.5,0.2c0.1,0,0,0.1,0,0.2l-0.1,0.2c0,0,0,0.1,0,0.1l-0.2,0.5c0,0.1-0.2,0.1-0.2,0.1l-0.4-0.1
	c-0.1,0-0.1-0.2-0.1-0.2l0.2-0.5c0,0,0,0,0-0.1l0.1-0.2C126.9,9.8,127,9.7,127,9.7z" />
        <radialGradient
          id="CSVGID_72_"
          cx="1222.7997"
          cy="1056.0402"
          r="8.7839"
          gradientTransform="matrix(-0.1896 -3.271905e-02 3.334267e-02 -0.1891 329.7807 254.9517)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst80"
          d="M131.4,15c0.2-0.9,1-1.5,2-1.4c0.9,0.2,1.5,1,1.4,1.9c-0.2,0.9-1,1.5-2,1.4C131.9,16.8,131.3,15.9,131.4,15z" />
        <path
          class="cst70"
          d="M132.6,14.6c0.1-0.4,0.5-0.7,0.8-0.6c0.3,0,0.6,0.5,0.5,0.9c-0.1,0.4-0.5,1.3-0.9,1.2
	C132.6,16,132.5,15,132.6,14.6z" />
        <path
          class="cst5"
          d="M133,14.2l0.5,0.1c0.1,0,0.1-0.1,0.1-0.1l0-0.2c0,0,0-0.1,0-0.1l0.1-0.5c0-0.1-0.1-0.2-0.1-0.2l-0.4-0.1
	c-0.1,0-0.2,0.1-0.2,0.2l-0.1,0.5c0,0,0,0.1,0,0.1l0,0.2C132.9,14.1,133,14.2,133,14.2z" />
        <radialGradient
          id="CSVGID_73_"
          cx="-329.5016"
          cy="-2462.1304"
          r="8.7833"
          gradientTransform="matrix(0.1882 -3.975507e-02 4.003794e-02 0.1883 301.3322 461.8683)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <circle class="cst81" cx="140.7" cy="11.3" r="1.7" />
        <path
          class="cst60"
          d="M141.5,11.7c0.1,0.4-0.2,0.8-0.5,0.9c-0.2,0.1-0.7-0.2-0.8-0.6c-0.1-0.4,0-1.4,0.3-1.5
	C140.9,10.4,141.4,11.3,141.5,11.7z" />
        <path
          class="cst5"
          d="M141.2,12.3l-0.5,0.1c-0.1,0-0.1,0.1-0.1,0.2l0,0.2c0,0,0,0.1,0,0.1l0.1,0.5c0,0.1,0.1,0.2,0.2,0.1l0.4-0.1
	c0.1,0,0.2-0.2,0.2-0.2l-0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C141.4,12.3,141.3,12.2,141.2,12.3z" />
        <radialGradient
          id="CSVGID_74_"
          cx="278.7177"
          cy="2161.9053"
          r="8.7838"
          gradientTransform="matrix(-0.1877 4.500827e-02 -4.657191e-02 -0.187 301.5007 404.8516)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst82"
          d="M146.8,13.5c-0.2-0.9,0.3-1.8,1.2-2c0.9-0.2,1.8,0.3,2.1,1.2c0.2,0.9-0.3,1.8-1.2,2
	C148,15,147.1,14.4,146.8,13.5z" />
        <path
          class="cst70"
          d="M147.7,12.7c-0.1-0.4,0.2-0.8,0.4-0.9c0.2-0.1,0.7,0.2,0.8,0.6c0.1,0.4,0,1.4-0.3,1.5
	C148.3,14,147.8,13.1,147.7,12.7z" />
        <path
          class="cst5"
          d="M148,12.2l0.5-0.1c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l-0.1-0.5c0-0.1-0.2-0.2-0.2-0.1l-0.4,0.1
	c-0.1,0-0.2,0.2-0.1,0.2l0.1,0.5c0,0,0,0.1,0,0.1l0,0.2C147.8,12.1,147.9,12.2,148,12.2z" />
        <radialGradient
          id="CSVGID_75_"
          cx="-249.3688"
          cy="-1809.693"
          r="8.7835"
          gradientTransform="matrix(0.1795 -6.840663e-02 6.842864e-02 0.1799 322.1406 314.6253)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst83"
          d="M155.1,5.6c0.3,0.9-0.1,1.8-1,2.2c-0.9,0.3-1.8-0.1-2.2-1c-0.3-0.9,0.1-1.8,1-2.2
	C153.8,4.3,154.8,4.7,155.1,5.6z" />
        <path
          class="cst60"
          d="M154.3,6.5c0.1,0.4-0.1,0.8-0.3,0.9c-0.2,0.1-0.7-0.1-0.9-0.5c-0.1-0.4-0.2-1.4,0.1-1.5
	C153.6,5.3,154.2,6.1,154.3,6.5z" />
        <path
          class="cst5"
          d="M154.2,7.1l-0.5,0.2c-0.1,0-0.1,0.1,0,0.2l0.1,0.2c0,0,0,0.1,0,0.1l0.2,0.5c0,0.1,0.2,0.1,0.2,0.1l0.4-0.1
	c0.1,0,0.1-0.2,0.1-0.2l-0.2-0.5c0,0,0-0.1,0-0.1l-0.1-0.2C154.3,7.2,154.2,7.1,154.2,7.1z" />
        <radialGradient
          id="CSVGID_76_"
          cx="599.6027"
          cy="1534.8142"
          r="8.7833"
          gradientTransform="matrix(-0.1893 3.558917e-02 -3.723776e-02 -0.1899 332.196 277.6246)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst84"
          d="M159.9,7.8c-0.2-0.9,0.4-1.8,1.3-2c0.9-0.2,1.8,0.4,2,1.4c0.2,0.9-0.4,1.8-1.3,2C161,9.4,160.1,8.8,159.9,7.8z
	" />
        <path
          class="cst70"
          d="M160.8,7.1c-0.1-0.4,0.2-0.8,0.5-0.9c0.3,0,0.7,0.2,0.8,0.6c0.1,0.4,0,1.4-0.4,1.5
	C161.4,8.4,160.9,7.5,160.8,7.1z" />
        <path
          class="cst5"
          d="M161.1,6.5l0.5-0.1c0.1,0,0.1-0.1,0.1-0.2l0-0.2c0,0,0-0.1,0-0.1l-0.1-0.5c0-0.1-0.1-0.2-0.2-0.2l-0.4,0.1
	c-0.1,0-0.2,0.2-0.2,0.2l0.1,0.5c0,0,0,0.1,0,0.1l0,0.2C161,6.4,161,6.5,161.1,6.5z" />
        <radialGradient
          id="CSVGID_77_"
          cx="4168.7505"
          cy="-971.369"
          r="8.7835"
          gradientTransform="matrix(-0.1858 -4.642847e-02 -4.711863e-02 0.1863 898.4365 377.5999)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst85"
          d="M168.1,2.6c-0.2,0.9,0.3,1.8,1.2,2c0.9,0.2,1.8-0.3,2-1.2c0.2-0.9-0.3-1.8-1.2-2
	C169.3,1.2,168.3,1.7,168.1,2.6z" />
        <path
          class="cst60"
          d="M169,3.4c-0.1,0.4,0.2,0.8,0.4,0.9c0.2,0.1,0.7-0.2,0.8-0.6c0.1-0.4,0.1-1.4-0.3-1.5
	C169.6,2.2,169.1,3,169,3.4z" />
        <path
          class="cst5"
          d="M169.2,4l0.5,0.1c0.1,0,0.1,0.1,0.1,0.2l0,0.2c0,0,0,0.1,0,0.1l-0.1,0.5c0,0.1-0.2,0.2-0.2,0.1L169,5.1
	c-0.1,0-0.2-0.2-0.1-0.2l0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C169.1,4.1,169.2,4,169.2,4z" />
        <radialGradient
          id="CSVGID_78_"
          cx="-1356.9556"
          cy="1883.9193"
          r="8.7835"
          gradientTransform="matrix(0.1843 5.353170e-02 5.349068e-02 -0.1849 325.6889 431.6389)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --primary-color-lighten-40,
                $primarycolorlighten40
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst86"
          d="M178,11.1c0.3-0.9-0.3-1.8-1.1-2.1c-0.9-0.3-1.8,0.3-2.1,1.2c-0.3,0.9,0.3,1.8,1.1,2.1
	C176.8,12.5,177.8,12,178,11.1z" />
        <path
          class="cst70"
          d="M177.2,10.2c0.1-0.4-0.2-0.8-0.4-0.9c-0.2-0.1-0.7,0.2-0.8,0.6c-0.1,0.4-0.1,1.4,0.2,1.5
	C176.5,11.5,177.1,10.6,177.2,10.2z" />
        <path
          class="cst5"
          d="M177,9.7l-0.5-0.2c-0.1,0-0.1-0.1,0-0.2l0.1-0.2c0,0,0-0.1,0-0.1l0.1-0.5c0-0.1,0.2-0.1,0.2-0.1l0.4,0.1
	c0.1,0,0.2,0.2,0.1,0.2l-0.1,0.5c0,0,0,0.1,0,0.1l-0.1,0.2C177.1,9.6,177,9.7,177,9.7z" />
        <radialGradient
          id="CSVGID_79_"
          cx="-925.7491"
          cy="-805.1637"
          r="8.7838"
          gradientTransform="matrix(0.1898 2.945734e-02 -2.965984e-02 0.1901 338.5114 189.5225)"
          gradientUnits="userSpaceOnUse">
          <stop
            offset="0"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
            " />
          <stop
            offset="1"
            style="
              stop-color: var(
                --secondary-color-lighten-35,
                $secondarycolorlighten35
              );
              stop-opacity: 0;
            " />
        </radialGradient>
        <path
          class="cst87"
          d="M188.3,9.5c-0.1,0.9-1,1.6-1.9,1.4c-0.9-0.1-1.6-1-1.4-1.9c0.1-0.9,1-1.6,1.9-1.4
	C187.8,7.7,188.5,8.5,188.3,9.5z" />
        <path
          class="cst60"
          d="M187.2,9.8c-0.1,0.4-0.5,0.7-0.7,0.7c-0.3,0-0.6-0.5-0.5-0.9c0.1-0.4,0.5-1.3,0.8-1.2
	C187.1,8.5,187.3,9.5,187.2,9.8z" />
        <path
          class="cst5"
          d="M186.8,10.3l-0.5-0.1c-0.1,0-0.1,0.1-0.1,0.2l0,0.2c0,0,0,0.1,0,0.1l-0.1,0.5c0,0.1,0.1,0.2,0.1,0.2l0.4,0.1
	c0.1,0,0.2-0.1,0.2-0.2l0.1-0.5c0,0,0-0.1,0-0.1l0-0.2C186.9,10.4,186.8,10.3,186.8,10.3z" />
      </svg>
    </div>

    <div class="scaled-head-svg-mobile container-footer">
      <svg
        class="footer-lights"
        version="1.1"
        id="Layer_1-footer-lights"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 2369.8 527.3"
        style="enable-background: new 0 0 2369.8 527.3"
        xml:space="preserve">
        <switch>
          <foreignObject
            requiredExtensions="&ns_ai;"
            x="0"
            y="0"
            width="1"
            height="1"></foreignObject>
          <g i:extraneous="self">
            <path
              class="st0"
              d="M0,176.4c206.6,48.7,380.7,239.2,616.6,236.7c369.7-3.8,621.7-254.8,871.8-259.6
			                            c250.1-4.8,508.7,248.5,881.4,260.5"></path>

            <radialGradient
              id="SVGID_1_"
              cx="-2113.6924"
              cy="-2008.4098"
              r="257.8696"
              gradientTransform="matrix(0.1746 8.075637e-02 -8.075632e-02 0.1746 346.0802 679.8837)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st1"
              d="M184.3,179.4c-11.5,24.9-41,35.7-65.8,24.2c-24.9-11.5-35.7-41-24.2-65.8c11.5-24.9,41-35.7,65.8-24.2
			C185,125.1,195.8,154.6,184.3,179.4z"></path>
            <path
              class="st2"
              d="M149.6,181c-4.9,10.5-19.6,15.5-26.1,12.5c-6.8-3.1-12.8-17.7-7.9-28.2c4.9-10.6,24.3-32.6,33.7-28.2
			C158.7,141.4,154.5,170.5,149.6,181z"></path>
            <path
              class="st3"
              d="M133.6,190l-14.7-6.8c-1.6-0.7-4,1.7-4.7,3.3l-2.5,5.4c-0.6,1.3-1.1,2.3-1.2,2.7l-6.1,13.2
			c-0.7,1.6,0.7,6.4,2.3,7.1l10.8,5c1.6,0.7,6.8-1,7.5-2.6L131,204c0.2-0.4,0.7-1.4,1.3-2.7l2.5-5.4
			C135.4,194.4,135.2,190.7,133.6,190z"></path>

            <radialGradient
              id="SVGID_2_"
              cx="-23.6868"
              cy="-2021.8158"
              r="257.8714"
              gradientTransform="matrix(0.179 7.049398e-02 -7.055520e-02 0.1789 334.8277 687.8067)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st4"
              d="M519.4,342.7c-10,25.5-38.9,38-64.4,28c-25.5-10-38-38.8-28-64.3c10-25.5,38.9-38,64.3-27.9
			C516.9,288.4,529.4,317.2,519.4,342.7z"></path>
            <path
              class="st2"
              d="M484.8,346.2c-4.3,10.8-18.6,16.6-25.3,14c-7-2.7-13.8-16.9-9.5-27.7c4.3-10.8,22.4-33.9,32-30.1
			C491.6,306.2,489,335.4,484.8,346.2z"></path>
            <path
              class="st3"
              d="M469.3,356.1l-15.1-5.9c-1.6-0.6-3.9,2-4.5,3.6l-2.2,5.5c-0.5,1.3-0.9,2.4-1.1,2.8l-5.3,13.5
			c-0.6,1.6,1.1,6.3,2.7,7l11,4.3c1.6,0.6,6.7-1.4,7.3-3l5.3-13.5c0.1-0.4,0.6-1.5,1.1-2.8l2.2-5.5
			C471.4,360.4,470.9,356.7,469.3,356.1z"></path>

            <radialGradient
              id="SVGID_3_"
              cx="3147.8066"
              cy="-1380.0682"
              r="257.873"
              gradientTransform="matrix(0.1881 -4.013778e-02 4.013776e-02 0.1881 279.977 705.5035)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st5"
              d="M865.2,309.2c5.7,26.8-11.4,53.1-38.1,58.9c-26.8,5.7-53.1-11.4-58.9-38.2c-5.7-26.8,11.4-53.1,38.2-58.9
			C833.1,265.4,859.4,282.4,865.2,309.2z"></path>
            <path
              class="st2"
              d="M838.3,331.3c2.4,11.4-6.3,24.2-13.3,25.7c-7.3,1.6-20.8-6.5-23.3-17.8c-2.4-11.4-0.1-40.6,10-42.8
			C821.8,294.2,835.9,320,838.3,331.3z"></path>
            <path
              class="st3"
              d="M830.9,348.1l-15.9,3.4c-1.7,0.4-2.1,3.8-1.8,5.5l1.2,5.8c0.3,1.4,0.5,2.5,0.6,2.9l3,14.2
			c0.4,1.7,4.4,4.7,6.1,4.3l11.6-2.5c1.7-0.4,4.8-4.9,4.4-6.6l-3-14.2c-0.1-0.4-0.3-1.5-0.6-2.9l-1.2-5.8
			C835,350.5,832.6,347.7,830.9,348.1z"></path>

            <radialGradient
              id="SVGID_4_"
              cx="5314.73"
              cy="-1078.6099"
              r="257.8705"
              gradientTransform="matrix(0.1815 -6.375504e-02 6.375499e-02 0.1815 270.1274 716.707)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st6"
              d="M1212.5,165.7c9.1,25.8-4.5,54.2-30.3,63.2c-25.8,9.1-54.2-4.5-63.2-30.4c-9.1-25.8,4.5-54.1,30.3-63.2
			C1175.2,126.3,1203.5,139.9,1212.5,165.7z"></path>
            <path
              class="st2"
              d="M1188.7,191.1c3.9,11-3.2,24.8-10,27.1c-7.1,2.5-21.5-3.8-25.3-14.7c-3.9-11-5.3-40.3,4.5-43.7
			C1167.6,156.3,1184.9,180.1,1188.7,191.1z"></path>
            <path
              class="st3"
              d="M1183.5,208.6l-15.3,5.4c-1.6,0.6-1.6,4-1,5.6l2,5.6c0.5,1.3,0.9,2.4,1,2.8l4.8,13.7c0.6,1.6,4.9,4.1,6.6,3.5
			l11.2-3.9c1.6-0.6,4.1-5.5,3.6-7.1l-4.8-13.7c-0.1-0.4-0.5-1.5-1-2.8l-2-5.6C1187.9,210.5,1185.1,208.1,1183.5,208.6z"></path>

            <radialGradient
              id="SVGID_5_"
              cx="5515.3179"
              cy="-4101.4126"
              r="257.8694"
              gradientTransform="matrix(0.1864 4.709109e-02 -4.724856e-02 0.1864 393.1028 608.3578)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st7"
              d="M1663.2,115.8c-6.7,26.5-33.7,42.6-60.3,35.9c-26.5-6.7-42.6-33.7-35.9-60.2c6.7-26.5,33.7-42.6,60.3-35.9
			C1653.8,62.3,1669.9,89.3,1663.2,115.8z"></path>
            <path
              class="st2"
              d="M1629.3,123.8c-2.9,11.3-16.4,18.9-23.3,17.1c-7.3-1.8-15.8-15-13-26.3c2.9-11.3,17.9-36.5,27.9-34
			C1630.9,83.2,1632.2,112.5,1629.3,123.8z"></path>
            <path
              class="st3"
              d="M1615.2,135.5l-15.7-4c-1.7-0.4-3.6,2.4-4,4.1l-1.5,5.7c-0.3,1.4-0.6,2.5-0.7,2.9l-3.6,14
			c-0.4,1.7,1.9,6.2,3.5,6.6l11.5,2.9c1.7,0.4,6.5-2.3,6.9-3.9l3.6-14c0.1-0.4,0.4-1.5,0.7-2.9l1.5-5.7
			C1617.9,139.5,1616.9,136,1615.2,135.5z"></path>

            <radialGradient
              id="SVGID_6_"
              cx="7115.5679"
              cy="-5492.9141"
              r="257.8773"
              gradientTransform="matrix(0.1744 8.112179e-02 -8.112174e-02 0.1744 351.5866 652.1816)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --secondary-color-lighten-35,
                    $secondarycolorlighten35
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st8"
              d="M2083,292.5c-11.6,24.8-41,35.6-65.9,24.1c-24.8-11.6-35.6-41.1-24-65.9c11.6-24.8,41.1-35.6,65.9-24.1
			C2083.7,238.1,2094.5,267.6,2083,292.5z"></path>
            <path
              class="st2"
              d="M2048.2,294c-4.9,10.5-19.6,15.5-26.1,12.5c-6.8-3.2-12.8-17.7-7.9-28.2c4.9-10.5,24.4-32.5,33.7-28.2
			C2057.4,254.4,2053.1,283.4,2048.2,294z"></path>
            <path
              class="st3"
              d="M2032.2,302.9l-14.7-6.8c-1.6-0.7-4,1.7-4.7,3.3l-2.5,5.4c-0.6,1.3-1.1,2.3-1.3,2.7l-6.1,13.1
			c-0.7,1.6,0.7,6.4,2.2,7.1l10.7,5c1.6,0.7,6.8-1,7.5-2.6l6.1-13.1c0.2-0.4,0.7-1.4,1.2-2.7l2.5-5.4
			C2034,307.3,2033.8,303.6,2032.2,302.9z"></path>

            <radialGradient
              id="SVGID_7_"
              cx="1434.098"
              cy="2286.2607"
              r="257.8759"
              gradientTransform="matrix(-0.1675 -9.458439e-02 9.458433e-02 -0.1675 269.2525 876.918)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st9"
              d="M202.2,334c13.5-23.9,43.7-32.3,67.6-18.8c23.8,13.5,32.3,43.7,18.8,67.6c-13.5,23.9-43.7,32.3-67.6,18.8
			C197.1,388.1,188.7,357.9,202.2,334z"></path>
            <path
              class="st10"
              d="M236.9,335.3c5.7-10.1,20.7-13.9,27-10.4c6.5,3.7,11.3,18.7,5.6,28.8c-5.7,10.1-26.9,30.5-35.8,25.4
			C224.7,374,231.2,345.4,236.9,335.3z"></path>
            <path
              class="st3"
              d="M253.6,327.6l14.1,8c1.5,0.8,4.1-1.4,4.9-2.9l2.9-5.2c0.7-1.2,1.3-2.2,1.5-2.6l7.1-12.6
			c0.9-1.5-0.2-6.4-1.7-7.3l-10.3-5.8c-1.5-0.8-6.8,0.5-7.7,2l-7.1,12.6c-0.2,0.4-0.8,1.4-1.5,2.6l-2.9,5.2
			C252.1,323.1,252.1,326.8,253.6,327.6z"></path>

            <radialGradient
              id="SVGID_8_"
              cx="-1705.1526"
              cy="2327.0325"
              r="257.8838"
              gradientTransform="matrix(-0.1922 -5.992205e-03 5.992180e-03 -0.1922 308.0277 914.0499)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st11"
              d="M600.2,475.4c0.9-27.4,23.7-48.9,51.1-48c27.4,0.9,48.9,23.7,48,51.1c-0.8,27.4-23.7,48.9-51.1,48
			C620.8,525.7,599.3,502.8,600.2,475.4z"></path>
            <path
              class="st10"
              d="M631.5,460.4c0.4-11.6,11.9-21.9,19.1-21.7c7.5,0.2,18.7,11.3,18.3,22.9c-0.4,11.6-9.6,39.5-19.9,39.2
			C638.7,500.4,631.2,472,631.5,460.4z"></path>
            <path
              class="st3"
              d="M642.7,445.9l16.2,0.5c1.7,0.1,3-3.2,3-4.9l0.2-5.9c0.1-1.4,0.1-2.6,0.1-3l0.4-14.5c0.1-1.7-3.1-5.6-4.9-5.7
			l-11.8-0.4c-1.7-0.1-5.8,3.6-5.9,5.3l-0.4,14.5c0,0.4-0.1,1.6-0.1,3l-0.2,5.9C639.3,442.5,641,445.8,642.7,445.9z"></path>

            <radialGradient
              id="SVGID_9_"
              cx="-4269.4277"
              cy="1243.8412"
              r="257.867"
              gradientTransform="matrix(-0.1783 7.219800e-02 -7.219796e-02 -0.1783 363.6482 912.0421)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st12"
              d="M989,400.7c-10.3-25.4,2-54.3,27.4-64.6c25.4-10.3,54.3,2,64.6,27.4c10.3,25.4-2,54.3-27.4,64.6
			C1028.2,438.3,999.2,426.1,989,400.7z"></path>
            <path
              class="st10"
              d="M1011.6,374.2c-4.4-10.8,2-24.9,8.7-27.6c6.9-2.8,21.6,2.8,26,13.5c4.4,10.8,7.2,40-2.4,43.9
			C1034.3,407.9,1015.9,385,1011.6,374.2z"></path>
            <path
              class="st3"
              d="M1015.9,356.4l15-6.1c1.6-0.7,1.4-4.1,0.8-5.7l-2.2-5.5c-0.5-1.3-1-2.4-1.1-2.8L1023,323
			c-0.6-1.6-5.1-3.9-6.7-3.2l-11,4.5c-1.6,0.6-3.9,5.7-3.2,7.3l5.4,13.4c0.2,0.4,0.6,1.5,1.1,2.8l2.2,5.5
			C1011.5,354.8,1014.3,357.1,1015.9,356.4z"></path>

            <radialGradient
              id="SVGID_10_"
              cx="-5692.3853"
              cy="2655.1714"
              r="257.8755"
              gradientTransform="matrix(-0.1906 2.239874e-02 -2.226182e-02 -0.1912 365.4436 867.2776)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st13"
              d="M1342.3,237.9c-3.2-27.2,16.3-51.9,43.4-55.1c27.1-3.2,51.7,16.3,54.9,43.5c3.2,27.2-16.3,51.9-43.4,55.1
			C1370,284.6,1345.4,265.1,1342.3,237.9z"></path>
            <path
              class="st10"
              d="M1371,218.4c-1.3-11.6,8.6-23.5,15.7-24.3c7.4-0.9,20.1,8.4,21.4,20c1.4,11.6-3.7,40.5-13.9,41.7
			C1383.9,256.9,1372.4,229.9,1371,218.4z"></path>
            <path
              class="st3"
              d="M1379.9,202.3l16.1-1.9c1.7-0.2,2.5-3.6,2.3-5.3l-0.7-5.9c-0.2-1.4-0.3-2.6-0.3-3l-1.7-14.4
			c-0.2-1.7-3.9-5.1-5.6-4.9l-11.8,1.4c-1.7,0.2-5.2,4.4-5,6.2l1.7,14.4c0,0.4,0.2,1.6,0.3,3l0.7,5.9
			C1376.1,199.5,1378.2,202.6,1379.9,202.3z"></path>

            <radialGradient
              id="SVGID_11_"
              cx="-7106.0469"
              cy="4382.2544"
              r="257.8865"
              gradientTransform="matrix(-0.189 -3.567589e-02 3.567587e-02 -0.189 298.9852 880.8192)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st14"
              d="M1749.5,297c5.1-26.9,31-44.6,57.9-39.5c26.9,5.1,44.6,31,39.5,57.9c-5.1,26.9-31,44.6-57.9,39.5
			C1762.1,349.8,1744.4,323.9,1749.5,297z"></path>
            <path
              class="st10"
              d="M1782.8,287c2.2-11.4,15.2-19.8,22.2-18.5c7.4,1.4,16.7,14,14.6,25.5c-2.2,11.4-15.6,37.5-25.8,35.6
			C1783.6,327.6,1780.6,298.4,1782.8,287z"></path>
            <path
              class="st3"
              d="M1796.1,274.4l15.9,3c1.7,0.3,3.4-2.7,3.7-4.4l1.1-5.8c0.3-1.4,0.5-2.5,0.6-2.9l2.7-14.3
			c0.3-1.7-2.2-6-3.9-6.3l-11.7-2.2c-1.7-0.3-6.3,2.7-6.6,4.4l-2.7,14.2c-0.1,0.4-0.3,1.6-0.6,2.9l-1.1,5.8
			C1793.2,270.5,1794.4,274.1,1796.1,274.4z"></path>

            <radialGradient
              id="SVGID_12_"
              cx="-10002.8936"
              cy="3105.5159"
              r="257.8762"
              gradientTransform="matrix(-0.192 -1.156983e-02 1.157245e-02 -0.192 288.3531 943.5314)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                "></stop>
              <stop
                offset="1"
                style="
                  stop-color: var(
                    --primary-color-lighten-40,
                    $primarycolorlighten40
                  );
                  stop-opacity: 0;
                "></stop>
            </radialGradient>
            <path
              class="st15"
              d="M2195.1,460.1c1.7-27.3,25.2-48.2,52.5-46.5c27.3,1.6,48.2,25.1,46.5,52.5c-1.6,27.3-25.1,48.2-52.5,46.5
			C2214.3,511,2193.4,487.5,2195.1,460.1z"></path>
            <path
              class="st10"
              d="M2226.9,446c0.7-11.6,12.6-21.6,19.7-21.2c7.5,0.5,18.3,11.8,17.6,23.4c-0.7,11.6-10.8,39.2-21.1,38.6
			C2232.9,486.2,2226.2,457.6,2226.9,446z"></path>
            <path
              class="st3"
              d="M2238.5,431.8l16.2,1c1.7,0.1,3.1-3.1,3.2-4.8l0.3-5.9c0.1-1.4,0.2-2.6,0.2-3l0.9-14.5c0.1-1.7-3-5.7-4.7-5.8
			l-11.8-0.7c-1.7-0.1-5.9,3.4-6,5.2l-0.9,14.5c0,0.4-0.1,1.6-0.2,3l-0.4,5.9C2235.2,428.4,2236.8,431.7,2238.5,431.8z"></path>
          </g>
        </switch>
      </svg>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: 'spooky-ghost',

  created() {},

  computed: {},

  data() {
    return {};
  },

  methods: {},

  mounted() {},

  props: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
@import '~assets/css/holiday/festivelights';

.container-root {
  position: relative;
  height: 0;
}

.container-header {
  position: relative;
  top: 30vh;
}

.container-footer {
  display: None;
  position: relative;
}
.header-lights {
  transform: scaleX(1.05);
}

.footer-lights {
  transform: scaleX(1.05);
}
</style>
